import { SerializedError } from "@reduxjs/toolkit"
import { FetchBaseQueryError } from "@reduxjs/toolkit/query"
import { useEffect, useState } from "react"

interface IProps {
    error?: FetchBaseQueryError | SerializedError
}

export function ViewError({ error }: IProps) {
    const [msg, setMsg] = useState("¡Ocurrió un error!")

    useEffect(() => {
        if (error) {
            if (isFetchBaseQueryError(error)) {
                const data = error.data as { errorMessage?: string }
                setMsg(data?.errorMessage ?? msg)
            } else if (isSerializedError(error)) {
                setMsg(error.message ?? msg)
            }
        }
    }, [error])

    return (
        <div className='container' role='alert'>
            <div className='alert alert-danger' role='alert'>
                {msg}
            </div>
        </div>
    )
}

// --- Helpers para discriminar tipos ---
function isFetchBaseQueryError(
    error: FetchBaseQueryError | SerializedError
): error is FetchBaseQueryError {
    return 'data' in error
}

function isSerializedError(
    error: FetchBaseQueryError | SerializedError
): error is SerializedError {
    return 'message' in error
}
